export default {"src":"/_next/static/image/public/images/ic_pom_product_icon_search.137dfd85024a8d568d478c1f84dbfff1.svg","height":14,"width":14};